import FadeUp from "./FadeUp";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const stats = [
    { value: "Ex Sunsama", label: "Head of Partnerships" },
    { value: "8 yrs", label: "In influencer marketing" },
    { value: "70+", label: "Brands worked with" },
    { value: "1,000+", label: "Campaigns run" },
];

export const Intro = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const scrollToAbout = () => {
        if (location.pathname === "/") {
            const el = document.getElementById("about");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            navigate("/#about");
        }
    };

    return (
        <section
            id="intro"
            data-testid="intro-section"
            className="py-16 md:py-24 bg-[#FAFAFA] border-y border-black/[0.06]"
        >
            <div className="container-page">
                <FadeUp>
                    <div
                        data-testid="intro-card"
                        className="rounded-3xl bg-white border border-black/[0.08] p-6 md:p-10 lg:p-12"
                    >
                        <div className="grid md:grid-cols-[auto_minmax(0,1fr)] gap-6 md:gap-10 items-center">
                            <div className="flex-none">
                                <div className="h-28 w-28 md:h-36 md:w-36 rounded-2xl overflow-hidden bg-[#FAFAFA] border border-black/[0.08]">
                                    <img
                                        src="/ambuj.jpg"
                                        alt="Ambuj Vats"
                                        loading="lazy"
                                        className="h-full w-full object-cover"
                                    />
                                </div>
                            </div>
                            <div>
                                <p
                                    data-testid="intro-copy"
                                    className="font-display font-bold text-[22px] md:text-[26px] lg:text-[28px] leading-[1.3] tracking-[-0.015em] text-[#0A0A0A] text-balance"
                                >
                                    Hi, I&apos;m Ambuj. I&apos;ve been an influencer operator for the last 8 years. Influencer marketing is all I know, and I can talk non-stop about it lol.
                                </p>
                                <p className="mt-4 text-[14.5px] md:text-[15px] text-gray-600 leading-relaxed max-w-2xl">
                                    I work with apps that save people time or use AI to boost productivity: daily planners, note takers, calendar tools, AI writing assistants, focus and workflow apps, and everything adjacent.
                                </p>
                                <button
                                    data-testid="intro-read-about"
                                    onClick={scrollToAbout}
                                    className="mt-6 inline-flex items-center gap-2 rounded-full h-11 px-5 bg-[#0A0A0A] hover:bg-black text-white text-sm font-semibold transition-all hover:-translate-y-[1px]"
                                >
                                    Read about me
                                    <ArrowRight className="h-4 w-4" />
                                </button>
                            </div>
                        </div>

                        <div className="mt-8 md:mt-10 pt-6 md:pt-8 border-t border-black/[0.06] grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
                            {stats.map((s, i) => (
                                <div key={i} data-testid={`intro-stat-${i}`}>
                                    <div className="font-display font-bold text-[17px] md:text-[19px] tracking-tight text-[#0A0A0A] leading-[1.3]">
                                        {s.value}
                                    </div>
                                    <div className="mt-1.5 text-[12.5px] text-gray-500 leading-[1.65]">
                                        {s.label}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </FadeUp>
            </div>
        </section>
    );
};

export default Intro;
